// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__K5Rcs","item":"style_item__13uCu"};